export const CONVERSATION_TITLE_INVALID = 'CONVERSATION_TITLE_INVALID';
export const ALL_INTENTS = 'ALL_INTENTS';
export const ALL_AGENTS = 'ALL_AGENTS';
export const CURRENT_AGENT_DETAILS = 'CURRENT_AGENT_DETAILS';
export const SET_SELECTED_AGENT = 'SET_SELECTED_AGENT';
export const GET_ALL_DEPLOYMENTS = 'GET_ALL_DEPLOYMENTS';
export const SET_DEPLOYMENTS_LOADER = 'SET_DEPLOYMENTS_LOADER';
export const SET_TRAINING_LOADER = 'SET_TRAINING_LOADER';
export const GET_DEPLOYMENTS = 'GET_DEPLOYMENTS';
export const TRAINING_UTTERANCES = 'TRAINING_UTTERANCES';
export const TRAINING_UTTERANCES_NOT_FOUND = 'TRAINING_UTTERANCES_NOT_FOUND';
export const TRAINING_SESSION_DATA_NOT_FOUND =
  'TRAINING_SESSION_DATA_NOT_FOUND';
export const TRAINING_SESSION_DATA = 'TRAINING_SESSION_DATA';
export const SET_TRAINING_SESSIONS_LOADER = 'SET_TRAINING_SESSIONS_LOADER';
export const CREATE_INTENT = 'CREATE_INTENT';
export const CREATE_INTENT_INPUT = 'CREATE_INTENT_INPUT';
